import {
    FieldInCard,
} from 'app/types/form.types'

type Values = {
    noteSubject: string,
    noteText: string,
    validDateTimestamp: string,
    attachments: number[],
}

type Fields = keyof Values

const noteFormFields: FieldInCard<Fields>[] = [{
    id: 'note',
    title: 'NOTE',
    fields: [
        {
            name: 'noteSubject',
            labelKey: 'NOTE_SUBJECT',
            componentName: 'InputSingleline',
        },
        {
            name: 'noteText',
            labelKey: 'NOTE_TEXT',
            componentName: 'LongText',
        },
        {
            name: 'validDateTimestamp',
            labelKey: 'VALID_DATE_TIMESTAMP',
            className: 'validDateTimestamp',
            componentName: 'DateTimeZonedSelect',
        },
        {
            name: 'attachments',
            labelKey: 'ATTACHMENTS',
            componentName: 'AttachmentsObjectSelector',
        },
    ],
}]

export default noteFormFields
